import React, { useMemo } from "react";
import { Field } from "react-final-form";

import RffInputWrapper from "../shared/RffInputWrapper";

import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";
import SelectInput from "../../inputs/SelectInput";

const RffSelectField = ({
  name,
  label,
  options,
  required = false,
  row = false,
  disabled,
  suppressGrid,
  size,
  helperText,
  // Text shown while nothing is selected. Omit for SelectInput's default
  // ("Select from the following"); pass one when the empty state carries
  // meaning of its own (e.g. "Whole project" on an optional property picker).
  placeholder,
  sx,
  // Fires after the field value changes — for dependent clears, mirroring
  // RffBooleanToggleField / RffSelectToggleField.
  onChange,
}) => {
  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required],
  );

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      required={required}
      row={row}
      helperText={helperText}
    >
      <Field
        name={name}
        validate={validate}
        render={({ input, meta }) => (
          <SelectInput
            label={label}
            {...(placeholder ? { placeholder } : {})}
            value={input?.value}
            onChange={(v) => {
              input.onChange(v);
              if (typeof onChange === "function") onChange(v);
            }}
            disabled={disabled}
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error}
            options={options}
          />
        )}
      />
    </RffInputWrapper>
  );
};

export default RffSelectField;
